<template>
    <div class="mt--1 pb-4">
        <portal to="dashboardStatsCards">
            <b-jumbotron
                class="pb-4 pt-5 d-flex"
                bg-variant="primary"
                :fluid="true"
            >
                <b-row class="mt-4">
                    <b-col
                        v-for="(item, idx) in statPaths"
                        :key="item.name"
                        :md="
                            idx < statPaths.length - 1
                                ? parseInt(12 / statPaths.length)
                                : ''
                        "
                        cols="12"
                    >
                        <router-link
                            v-if="
                                item.name == 'orders' || isPermitted(item.name)
                            "
                            :to="item.path"
                        >
                            <stats-card
                                :title="item.title"
                                :type="`gradient-${item.color}`"
                                :sub-title="item.subTitle"
                                :icon-name="getIconName(item.name)"
                                :count="item.count"
                                icon-color="bg-primary"
                            ></stats-card>
                        </router-link>
                        <stats-card
                            v-else
                            :title="item.title"
                            :type="`gradient-${item.color}`"
                            :sub-title="item.subTitle"
                            :icon-name="getIconName(item.name)"
                            :count="item.count"
                            icon-color="bg-primary"
                        ></stats-card>
                    </b-col>
                </b-row>
            </b-jumbotron>
        </portal>
        <b-overlay :show="!loaded" rounded="sm">
            <b-card no-body>
                <b-tabs pills card v-model="tabIndex" justified>
                    <b-tab title="Locations">
                        <b-row>
                            <b-col md="6" class="mt-2">
                                <officers-map
                                    key="officerMap"
                                    :loaded="loaded"
                                    :officers="officers"
                                    :roles="roles"
                                />
                            </b-col>
                            <b-col md="6" class="mt-2">
                                <asset-map
                                    key="AssetMap"
                                    :loaded="loaded"
                                    :assets="assets"
                                    :asset-types="assetTypes"
                                />
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab title="Customer">
                        <customer-charts
                            :officers="officers"
                            :roles="roles"
                            :orders="orders"
                            :order-types="orderTypes"
                        ></customer-charts>
                    </b-tab>
                    <b-tab title="Analytics">
                        <analytics-charts
                            :officers="officers"
                            :roles="roles"
                            :orders="orders"
                            :order-types="orderTypes"
                        ></analytics-charts>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
import layoutMixins from '../mixins/layoutMixins'
import { capitalCase } from 'change-case'
import OfficersMap from './Dashboard/OfficersMap'
import AssetMap from './Dashboard/AssetMap'
import CustomerCharts from './Dashboard/CustomerCharts.vue'
import AnalyticsCharts from './Dashboard/AnalyticsCharts.vue'
import StatsCard from '@/components/StatsCard.vue'

export default {
    components: {
        OfficersMap,
        AssetMap,
        StatsCard,
        CustomerCharts,
        AnalyticsCharts,
    },
    mixins: [layoutMixins],
    data() {
        return {
            tabIndex: 0,
            toggleFeedback: true,
            selectedType: null,
            loaded: false,
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },

    computed: {
        filteredOfficers() {
            return this.officers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        officers() {
            return this.$store.getters['js_report/officers']
        },
        roles() {
            return this.$store.getters['js_report/roles']
        },
        assets() {
            return this.$store.getters['js_report/assets']
        },
        assetTypes() {
            return this.$store.getters['js_report/assetTypes']
        },
        orders() {
            return this.$store.getters['js_report/orders']
        },

        orderTypes() {
            return this.$store.getters['js_report/orderTypes']
        },

        stats() {
            return this.$store.getters['js_report/stats']
        },

        statPaths() {
            return [
                {
                    name: 'users',
                    path: '/admin/users',
                    color: 'red',
                    title: 'Users',
                    subTitle: 'Users',
                    count: this.stats.users.toString(),
                },
                {
                    name: 'customers',
                    path: '/admin/customers',
                    color: 'green',
                    title: 'Customers',
                    subTitle: 'Customers',
                    count: this.stats.customers.toString(),
                },
                {
                    name: 'locations',
                    path: '/admin/locations',
                    color: 'info',
                    title: 'Locations',
                    subTitle: 'Locations/Warehouses',
                    count: this.stats.locations.toString(),
                },
                {
                    name: 'orders',
                    path: '/admin/activities',
                    color: 'orange',
                    title: 'Activities',
                    subTitle: 'Activities',
                    count: this.stats.orders.toString(),
                },
            ]
        },
    },
    watch: {
        officers: {
            handler: function (val) {
                if (val) this.loaded = true
            },
            deep: true,
        },
    },
    created() {
        this.$store.dispatch('js_report/getDashboardData')
    },
}
</script>
<style scoped>
.row.no-gutters {
    margin-right: 0;
    margin-left: 0;
}
</style>
